import { RView1jxdnn5qf89cm as RView } from '../RView.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RowWrappingClass;
function RowWrapping() {
  if (RowWrappingClass === VOID) {
    class $ extends RView() {
      constructor(context) {
        super(context);
        this.tb5_1.xb3_1 = 'div';
        this.tb5_1.ab9('display', 'flex');
        this.tb5_1.ab9('flex-direction', 'row');
        this.tb5_1.ab9('flex-wrap', 'wrap');
        var tmp0 = this.tb5_1.hb4_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = 'kiteui-flex';
        tmp0.v(element);
        var tmp0_0 = this.tb5_1.hb4_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element_0 = 'kiteui-row-wrap';
        tmp0_0.v(element_0);
      }
      ub9(index, view) {
        super.ub9(index, view);
        var horizontalAlign = view.tb5_1.db4_1;
        var verticalAlign = view.tb5_1.cb4_1;
        switch (horizontalAlign == null ? -1 : horizontalAlign.b4_1) {
          case 0:
            view.tb5_1.ab9('justify-self', 'start');
            break;
          case 1:
            view.tb5_1.ab9('justify-self', 'center');
            break;
          case 2:
            view.tb5_1.ab9('justify-self', 'end');
            break;
          default:
            view.tb5_1.ab9('justify-self', 'stretch');
            break;
        }
        switch (verticalAlign == null ? -1 : verticalAlign.b4_1) {
          case 0:
            view.tb5_1.ab9('align-self', 'start');
            break;
          case 1:
            view.tb5_1.ab9('align-self', 'center');
            break;
          case 2:
            view.tb5_1.ab9('align-self', 'end');
            break;
          default:
            view.tb5_1.ab9('align-self', 'stretch');
            break;
        }
      }
    }
    initMetadataForClass($, 'RowWrapping');
    RowWrappingClass = $;
  }
  return RowWrappingClass;
}
//region block: exports
export {
  RowWrapping as RowWrapping1cfo2cqk4jxme,
};
//endregion

//# sourceMappingURL=Column.commonHtml.mjs.map
